<app-page-layout>
    <div class="flex min-h-screen flex-col-reverse md:flex-row">
        <!-- Branding -->
        <app-page-section class="bg-primary/7">
            <app-branding-panel [branding]="branding">
            </app-branding-panel>
        </app-page-section>

        <!-- Login -->
        <app-page-section [center]="true">
            <app-content-wrapper>
                <app-login-form></app-login-form>
            </app-content-wrapper>
        </app-page-section>
    </div>
</app-page-layout>